import * as VueRouter from 'vue-router';

// Layouts
const Layout = () => import('./Layouts/Layout.vue');

const Home = () => import('./Pages/Home.vue');
const Booking = () => import('./Pages/Booking.vue');
const GroupBooking = () => import('./Pages/GroupBooking.vue');
const GiftCard = () => import('./Pages/GiftCard.vue');
const GiftCardPaymentResult = () => import('./Pages/GiftCardPaymentResult.vue');

const routes = [
	{
		path: '/',
		component: Layout,
		children: [
			{
				path: '/',
				name: 'home',
				component: Home,
			},
			{
				path: '/booking/:ticketId?',
				name: 'booking',
				component: Booking,
			},
			{
				path: '/group-booking/:ticketId?',
				name: 'group-booking',
				component: GroupBooking,
			},
			{
				path: '/gift-card/:slug',
				name: 'gift-card',
				component: GiftCard,
			},
			{
				path: '/gift-card-payment',
				name: 'gift-card-payment-result',
				component: GiftCardPaymentResult,
			},
		]
	},
	{path: '/:pathMatch(.*)*', name: '404', redirect: '/'},
]

const router = VueRouter.createRouter({
	history: VueRouter.createWebHistory(),
	routes,
});
export default router;
